import { useLang } from '@/i18n';
import css from './index.module.scss';

const L: React.FC = () => {
    const { t } = useLang('ces2026.L');

    return (
        <div id="ces-2026-L" className={`ces-2026-L ${css.section} GtmModuleData-section`} data-section-id={'ces-2026-L'}>
            <div className="box">
                <p className="name">{t('name')}</p>
                <p className="text">{t('text')}</p>
            </div>
        </div>
    );
};

export default L;
